module.exports = __webpack_public_path__ + "img/abc.0f4fccba.png";